(function () {
  "use strict";

  if (!window.DNB) {
    return;
  }
})();